// Meta IG User /media: up to three collaborators, never on Story containers.
const MAX_INSTAGRAM_COLLABORATORS = 3;

function invalid(message) {
  const error = new Error(message);
  error.statusCode = 400;
  return error;
}

function normalizeInstagramCollaborators(value = []) {
  if (typeof value !== 'string' && !Array.isArray(value)) {
    throw invalid('Instagram collaborators must be usernames.');
  }
  const entries = typeof value === 'string' ? value.split(/[\s,]+/) : value;
  const usernames = [];
  for (const entry of entries) {
    if (typeof entry !== 'string') throw invalid('Enter a valid Instagram username.');
    const username = entry.trim().replace(/^@/, '').toLowerCase();
    if (!username) continue;
    if (!/^[a-z0-9_](?:[a-z0-9_.]{0,28}[a-z0-9_])?$/.test(username) || username.includes('..')) {
      throw invalid('Use Instagram usernames, not profile links (up to 30 characters).');
    }
    if (!usernames.includes(username)) usernames.push(username);
  }
  if (usernames.length > MAX_INSTAGRAM_COLLABORATORS) {
    throw invalid('Instagram supports up to 3 collaborators per post.');
  }
  return usernames;
}

function validateInstagramCollaboration(value, contentFormats = [], ownUsernames = []) {
  const usernames = normalizeInstagramCollaborators(value);
  if (!usernames.length) return usernames;
  const formats = Array.isArray(contentFormats) ? contentFormats : [];
  if (formats.length && !formats.some((format) => ['image', 'video', 'reel', 'short', 'carousel'].includes(format))) {
    throw invalid('Instagram collaboration is available for feed images and Reels, not Story-only or text posts.');
  }
  const owners = ownUsernames.map((value) => String(value || '').replace(/^@/, '').toLowerCase());
  if (usernames.some((username) => owners.includes(username))) {
    throw invalid('A publishing Instagram account cannot also be its own collaborator.');
  }
  return usernames;
}

function instagramCollaboratorParams(usernames, mediaType) {
  return usernames.length && mediaType !== 'STORIES'
    ? { collaborators: JSON.stringify(usernames) }
    : {};
}

module.exports = { MAX_INSTAGRAM_COLLABORATORS, normalizeInstagramCollaborators, validateInstagramCollaboration, instagramCollaboratorParams };
